import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Main } from './component/main/main';

import './i18n/config';
import i18n from './i18n/config';
import { t } from 'i18next';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

i18n.changeLanguage(navigator.language);

document.title = t("title")

root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
